import { render, staticRenderFns } from "./stockFlowList.vue?vue&type=template&id=0dce0ebd&scoped=true"
import script from "./stockFlowList.vue?vue&type=script&lang=js"
export * from "./stockFlowList.vue?vue&type=script&lang=js"
import style0 from "./stockFlowList.vue?vue&type=style&index=0&id=0dce0ebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce0ebd",
  null
  
)

export default component.exports